// ── Destino de un enlace: qué se puede aceptar ───────────────────────────────
//
// Vive acá y no en el servidor porque los dos lados tienen que decidir lo mismo:
// el panel avisa mientras se escribe y el servidor decide al guardar. Dos copias
// de estas reglas se separan en la primera corrección que se le haga a una sola.
//
// El servidor sigue siendo la autoridad: que el navegador haya dicho que sí no
// exime de volver a preguntar al aplicar.
/** Máximo de un destino. Una URL de verdad no llega ni cerca. */
export const MAX_HREF_LENGTH = 2_000;
/** Esquemas aceptados. Todo lo demás —javascript:, data:, file:— se rechaza. */
const HREF_SCHEMES = new Set(['http', 'https', 'mailto', 'tel']);
/**
 * Valida y normaliza un destino. Devuelve null si no se puede aceptar.
 *
 * Lista blanca, no lista negra: se enumera lo que puede pasar y todo lo demás
 * muere. Rechazar `javascript:` a mano no alcanza — el navegador acepta
 * `java<TAB>script:`, `JAVASCRIPT:` y `  javascript:` como lo mismo, así que la
 * comprobación va DESPUÉS de sacar los caracteres de control, y compara el
 * esquema entero contra la lista en vez de buscar subcadenas prohibidas.
 */
export function normalizeHref(raw) {
    const limpio = raw.replace(/[\u0000-\u001F\u007F]/g, '').trim();
    if (limpio === '' || limpio.length > MAX_HREF_LENGTH)
        return null;
    // Un destino no lleva espacios en el medio. Si quedó alguno después de limpiar
    // los controles, el valor venía armado para confundir a alguien.
    if (/\s/.test(limpio))
        return null;
    // Ancla dentro de la misma página.
    if (limpio.startsWith('#'))
        return /^#[\w-]+$/.test(limpio) ? limpio : null;
    // Relativo al protocolo (//host/x): sale del sitio sin decir con qué esquema.
    // Se pide explícito, así lo que se ve en el panel es lo que se va a navegar.
    if (limpio.startsWith('//'))
        return null;
    const conEsquema = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(limpio);
    if (conEsquema) {
        const esquema = conEsquema[1].toLowerCase();
        if (!HREF_SCHEMES.has(esquema))
            return null;
        if (esquema === 'http' || esquema === 'https') {
            try {
                const u = new URL(limpio);
                // new URL() acepta cosas que después navegan a otro lado; se confirma que
                // el esquema que quedó es el que se leyó.
                if (u.protocol !== `${esquema}:`)
                    return null;
                return u.toString();
            }
            catch {
                return null;
            }
        }
        // mailto: y tel: no tienen host que normalizar. Solo se acota el juego de
        // caracteres para que no puedan cerrar el atributo.
        return /^(?:mailto|tel):[^"'<>`]+$/i.test(limpio) ? limpio : null;
    }
    // Ruta del propio sitio: /contacto, gracias.html, ./x?a=1#b
    return /^[\w./~-][\w./?#=&%~+-]*$/.test(limpio) ? limpio : null;
}
//# sourceMappingURL=href.js.map